export const RADIUS_OPTIONS = [
  { value: '100', label: '100m' },
  { value: '200', label: '200m' },
  { value: '500', label: '500m' },
]

export const DEFAULT_RADIUS = 200

export const CHART_COLORS = {
  BUILDING: '#3b82f6',
  NEIGHBORHOOD_AVG: '#10b981',
  NEIGHBORHOOD_MAX: '#f59e0b',
}

export const AGE_DISTRIBUTION_KEYS = [
  'pre_1919',
  '1919_1945',
  '1946_1960',
  '1961_1970',
  '1971_1980',
  '1981_1990',
  '1991_2000',
  '2001_2010',
  '2011_2020',
  'post_2020',
] as const

export const CONFORMITY_WEIGHTS = {
  TEMPORAL: 0.4,
  PHYSICAL: 0.4,
  TYPOLOGICAL: 0.2,
}

export const COMPARISON_THRESHOLD = 10
